import { IEditGameDeveloperState } from './editDeveloperModalContext';
import { EditGameDeveloperActionTypes, TEditGameDeveloperAction } from '../editDeveloperModalActions';

export const editGameDeveloperReducer = (
	state: IEditGameDeveloperState,
	action: TEditGameDeveloperAction,
): IEditGameDeveloperState => {
	switch (action.type) {
		case EditGameDeveloperActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditGameDeveloperActionTypes.SET_ALL_DATA:
			return {
				...state,
				developerID: action.payload.id,
				name: action.payload.name,
			};
		case EditGameDeveloperActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case EditGameDeveloperActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditGameDeveloperActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditGameDeveloperActionTypes.RESET_FIELDS:
			return {
				...state,
				name: '',
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
